<h2 mat-dialog-title>Reset password per {{username ? username : '--'}}</h2>

<mat-dialog-content class="mat-typography">
    <div>
        <form [formGroup]="form" *ngIf="form" class="d-flex flex-column">
            <mat-form-field appearance="fill" class="mb-5">
                <mat-label>Password</mat-label>
                <input matInput formControlName="password">
                <mat-error *ngIf="form.get('password').hasError('required')">
                    Questo campo è obbligatorio
                </mat-error>
                <mat-error *ngIf="form.get('password').hasError('pattern')">
                    La password deve contenere almeno 8 caratteri (assicurati di inserire maiuscole, numeri e caratteri speciali)
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Conferma password</mat-label>
                <input matInput formControlName="retypedPassword">
                <mat-error *ngIf="form.get('retypedPassword').hasError('required')">
                    Questo campo è obbligatorio
                </mat-error>
                <mat-error *ngIf="form.get('retypedPassword').hasError('passwordMismatch')">
                    Le password non coincidono
                </mat-error>
            </mat-form-field>
        </form>

    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="pt-4 pb-4">
    <button mat-button (click)="send()" [disabled]="form.invalid">Conferma</button>
    <button mat-button mat-dialog-close>Annulla</button>
</mat-dialog-actions>